module.exports = __webpack_public_path__ + "4344b5d2a37141fcd791c13ce44c3d25.png";